import StorageUtils from '@spothero/utils/storage';
import { StorageKeys, StorageTypes } from 'common/constants/storageKeys';
import { getFeatureVariation, OPTIMIZELY_FEATURE_OFF, } from 'plugins/optimizely/hooks/use-feature-variation';
export { getWebExperimentCookie as getOptimizelyUserId } from 'utils/web-experiment';
export const IMMEDIATE_FEATURES = {
    AIRPORT_CHECKOUT_V2: 'airport_checkout_v2',
    AIRPORT_INSURANCE_UPSELL: 'airport_insurance_upsell',
    EVENT_PARKED_CAR_PROTECTION: 'event_parked_car_protection',
    VIEW_RATINGS_FILTER: 'view_ratings_filter',
    EXPRESS_CHECKOUT_WEB_DESKTOP_REFRESH: 'express_checkout_web_desktop_refresh_v2',
    USE_NEW_GOOGLE_PLACES_API: 'use_new_google_places_api',
    ACQUISITION_NEW_USER: 'acquisition_new_user',
    ACQUISITION_SEARCH_MAP_LIMIT_VALUES: 'acquisition_search_map_limit_values',
    ACQUISITION_DESKTOP_WEB_DATETIME_PICKER: 'acquisition_desktop_web_datetime_picker',
    ACQUISITION_ALL_IN_PRICING: 'acquisition_all_in_pricing_v2',
    AIRPORT_BOOK_NOW_TEST: 'airport_book_now_test',
};
export const VARIABLE_KEYS = {
    WAIT_TIME_SECONDS: 'wait_time_seconds',
};
export const getExperimentVariationFromCookie = (experimentName, defaultVariation = OPTIMIZELY_FEATURE_OFF) => {
    const experimentVariations = StorageUtils.get(StorageKeys.EXPERIMENT_VARIATIONS, StorageTypes.COOKIE);
    return experimentVariations?.[experimentName] || defaultVariation;
};
export const getExperimentsFromCookie = () => {
    const experiments = StorageUtils.get(StorageKeys.EXPERIMENT_VARIATIONS, StorageTypes.COOKIE);
    return experiments || {};
};
export const setExperimentVariationInCookie = (experimentName, variationName) => {
    const experimentVariations = StorageUtils.get(StorageKeys.EXPERIMENT_VARIATIONS, StorageTypes.COOKIE);
    if (experimentVariations) {
        experimentVariations[experimentName] = variationName;
        StorageUtils.set(StorageKeys.EXPERIMENT_VARIATIONS, experimentVariations, StorageTypes.COOKIE);
    }
    else {
        StorageUtils.set(StorageKeys.EXPERIMENT_VARIATIONS, { [experimentName]: variationName }, StorageTypes.COOKIE);
    }
};
export const removeExperimentVariationFromCookie = (experimentName) => {
    const experimentVariations = StorageUtils.get(StorageKeys.EXPERIMENT_VARIATIONS, StorageTypes.COOKIE);
    if (experimentVariations && experimentVariations[experimentName]) {
        delete experimentVariations[experimentName];
        StorageUtils.set(StorageKeys.EXPERIMENT_VARIATIONS, experimentVariations, StorageTypes.COOKIE);
    }
};
export const getFeatureFromCookieWithFallback = (optimizely, featureKey, { generateImpression } = {
    generateImpression: false,
}) => {
    const variation = getExperimentVariationFromCookie(IMMEDIATE_FEATURES.EXPRESS_CHECKOUT_WEB_DESKTOP_REFRESH, null);
    if (!variation) {
        return getFeatureVariation(optimizely, featureKey, {
            generateImpression,
        });
    }
    else {
        return variation;
    }
};
export const generateImpression = (optimizelyClient, flagName) => {
    const selectedVariation = getFeatureVariation(optimizelyClient, flagName, {
        generateImpression: true,
    });
    setExperimentVariationInCookie(flagName, selectedVariation);
};
export const setUserExposedtoExperimentInCookie = (experiment, cookieExpiry = 1) => {
    StorageUtils.set(experiment, true, StorageTypes.COOKIE, cookieExpiry // Expire after 30 days
    );
};
export const getUserExposedtoExperimentFromCookie = experiment => {
    const hasBeenExposed = StorageUtils.get(experiment, StorageTypes.COOKIE);
    return Boolean(hasBeenExposed);
};
